<template>
  <div class="mailPaperMaterials" v-wechat-title="this.text">
    <!-- 驳回提示 -->
    <div class="upload-status" v-if="showReviewResult&&itemStatus.status=='审核不通过'" >
      <div class="status"><img width="16px" style="margin-right:3px;" src="/static/upload/refuseIcon.png" />审核不通过</div>
      <div v-if="itemStatus.reasons" class="reason">驳回原因：<br />{{itemStatus.reasons}}</div>
    </div>

    <!-- 纸质材料 -->
    <!-- <div style="margin: 16px;font-size:14px;">第{{phase}}阶段申请材料</div> -->
    <div style="margin: 16px;font-size:14px;">第{{rounds}}轮次第{{rounds_phase}}周期申请材料</div>
    <div v-if="!isLoading">
      <!-- <template v-for="(item, index) in checkItems">
        <div class="upload-list" :key="index" v-if="active == index"> -->
          <div class="upload-list" >
          <van-cell-group :title="text" :border="false">
            <!-- 点击跳转详情页 <van-cell v-for="(citem, cindex) in mailItems" :key="cindex" @click="goItem(citem,cindex)" value-class="cell-value"> -->
            <van-cell v-for="(citem, cindex) in mailItems" :key="cindex" value-class="cell-value">
              <template #title>
              <!-- <div style="height:55px;"> -->
                <span class="custom-title" :style="{color:citem.result.status=='审核不通过'?  showReviewResult?'red':''  :''}">
                  <!-- {{citem.name+'（'+ citem.attach.length +'张）'}} -->
                  {{citem.name}}
                </span>
              <!-- </div> -->
              </template>
              <div  style="height:55px;width:55px;margin:0 0 0 10px;text-align:center;">
                <img v-if="item_img_url(citem)" :src="item_img_url(citem)" @click="showPic(citem.attach)" width="55px" height="55px" />
              </div>
            </van-cell>
          </van-cell-group>
          </div>
        <!-- </div>
      </template> -->
    </div>

    <!-- 地址 -->
    <!-- <div class="address">
        <div class="status"><img width="16px" style="margin-right:3px;" src="/static/upload/refuseIcon.png" />请将申请材料寄往下方邮寄地址</div>
        <div class="copyAddress">
          <div>资料邮寄地址:</div>
          <van-button v-clipboard:copy="copyText"  @click="toastText('复制成功!')" 
            type="primary" size="mini" plain color="#0AA8AF">复制地址</van-button>
        </div>
        <div>{{copyText}}</div>
    </div> -->

    <!-- 随访评估 -->
    <div class="appoint-notice-container">
      <!-- <div class="appoint-notice"> -->
          <!-- <div v-if="toggleText" style="font-size:14px;color:red;margin:5px;">*本次需要您前往项目医生处完成一次随访评估。</div>
          <div v-else  style="font-size:14px;color:red;margin:5px;">*项目办建议每3个月前往项目医生处完成一次随访评估。</div> -->
          <div style="font-size:14px;color:red;margin:21px;">*项目办建议第1轮次每2个月前往项目医生处完成一次随访评估；第2、3轮次每3个月前往项目医生处完成一次随访评估。</div>
      <!-- </div> -->

      <div class="appoint-notice" >
        <div class="address">
          <div class="copyAddress">
            <div style="font-size:16px;">邮寄地址:</div>
            <van-button v-clipboard:copy="copyText"  @click="toastText('复制成功!')" 
              type="primary" size="small" plain color="#0AA8AF">复制地址</van-button>
          </div>
          <div>{{copyText}}</div>
          <div style="font-size:12px;color:#0AA8AF;margin-top:10px;">请您将{{itemStatus.status=='审核不通过'?  showReviewResult?'驳回':phase==1?'':'随访'  :   phase==1?'':'随访' }}材料邮寄至上方邮寄地址（只接收EMS特快专递），如有问题请联系项目办： 010-56592455。</div>
        </div>
      </div>
      <div style="font-size:12px;text-align:left;margin-bottom:50px;margin:0 20px;">
        <span v-if="field_3||field_4">*您最近一次的随访</span>
        <span v-if="field_3">时间是{{field_3}}</span>
        <span v-if="field_3&&field_4">，</span>
        <span v-if="field_4">检查部位是：{{field_4}}</span>
      </div>
    </div>

    <!-- 返回按钮 -->
    <div class="btn stay-bottom">
        <van-button type="default" class="up" @click="goNext" :disabled="disabled" color="#0AA8AF">{{btntxt}}</van-button>
        <!-- <van-button v-if="active != 0" type="default" class="back" @click="toPrev()">上一步</van-button> -->
    </div>
  </div>
</template>

<script>
  var jweixin = require('jweixin-module')
  import {
    GetPatient,
    CheckItemStatus,
    GetCheckItem,
    UploadPatientStatus
  } from '../../api/api';
  import Vue from 'vue';
  import {
    mapState
  } from "vuex";
  import {
    Toast,
    ImagePreview
  } from 'vant';

  Vue.use(Toast);
  export default {
    data() {
      return {
        isLoading: true,
        papid: '',
        patient_id: '',
        category: '',
        checkItems: [],
        active: 0,
        list: [],
        btntxt: '返回首页',
        disabled: false,
        checked: false,
        text: '邮寄材料',
        showcheck: false,
        follow: false,

        phase:'1',//第几阶段
        mailItems:[],
        patientInfo:null,//患者对象
        copyText:"北京市100024信箱59号分箱 中国初级卫生保健基金会“择美同行-患者援助项目办公室”（只接受EMS特快专递）",
        itemStatus:{status:"",reasons:""},

        field_3:'',
        field_4:'',

        rounds:"",
        rounds_phase:'',

        showReviewResult:false,//综合审核完成后才显示审核结果

      }
    },
    computed: {
      // ...mapState(['userInfo','patientInfo','patientOne']),
      ...mapState(['userInfo','patientOne']),
    },
    async mounted() {
      if (this.$route.query.active) {
        this.active = parseInt(this.$route.query.active);
      }
      if (this.$route.query.follow) {
        this.follow = this.$route.query.follow;
      }
      if (this.$route.query.category) {
        this.category = this.$route.query.category;
      }
      // console.log(this.active, this.$route.query)
      if (this.userInfo.patient) {
        this.papid = this.userInfo.patient.papid
        this.patient_id = this.userInfo.patient.id
      }
      // if(window.localStorage.getItem('check')){
      //   if(window.localStorage.getItem('check') === 'false'){
      //     this.checked = false
      //   }else{
      //     this.checked = true
      //   }
      // }
      await this.getData()
      window.localStorage.setItem('ischeck', 'true')
      this.$forceUpdate()
    },
    methods: {
      async getData() {
        Toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true
        });
        let res = await GetPatient({ papid: this.papid })
        const {
          patient,
          drugstore,
          phase,
          predict,
          volunteer,
          mode_name,
          rounds_phase,
          phase_drug_field,
          phase_drug_field_3
        } = res.data;
        this.phase=patient.receive_phase
        this.rounds=phase.rounds
        this.rounds_phase=rounds_phase
        if(phase_drug_field){
          this.field_3=phase_drug_field.field_3;
          this.field_4=phase_drug_field.field_4;
          if(phase_drug_field_3){
            if(!this.field_3) this.field_3=phase_drug_field_3.field_3
            if(!this.field_4) this.field_4=phase_drug_field_3.field_4
          }
        }
        console.log("phase.status邮寄材料",phase.status)
        if(phase.status!="审核通过"&&phase.status!="等待审核"&&phase.status!="预约申请通过"){
          this.showReviewResult=true;
          this.itemStatus.status="审核不通过"
        }

        let ci = await GetCheckItem({
          papid: this.papid,
          category: this.category,
          phase: res.data.patient.receive_phase
        })
        this.patientInfo=res.data
        console.log("this.patientInfo",this.patientInfo)
        // if(this.patientInfo.phase_info) this.phase=this.patientInfo.phase_info.phase

        //把所有审核项放到mailItems里
        let temp =[]
        this.mailItems=[]
        ci.data.forEach(ele=>{ temp=[...temp,...ele.data] })
        //筛选出邮寄材料
        // if(patient.rounds==1&&rounds_phase==1){//第一轮次时,邮寄固定的几个材料
        //   temp.forEach(ele=>{ 
        //     //不显示购药发票的情况
        //     console.log("(!this.patientInfo.phase_info||!this.patientInfo.phase_info.number)",(!this.patientInfo.phase_info||!this.patientInfo.phase_info.number))
        //     if((!this.patientInfo.phase_info||!this.patientInfo.phase_info.number)&&ele.name.indexOf('购药发票')>=0)  return
        //     //需要邮寄的材料:
        //     // 5.近期非小细胞肺癌住院病案首页及出院小结
        //     // 6.确诊为非小细胞肺癌的病理报告
        //     // 7.基因检测报告单
        //     // 8.近2个月内原发灶或转移灶的影像学检查   
        //     // 9.《医学条件确认表》
        //     // 10.购药发票
        //     if(ele.name.indexOf("非小细胞肺癌")>=0) this.mailItems.push(ele)
        //     if(ele.name.indexOf("基因检测报告单")>=0) this.mailItems.push(ele)
        //     if(ele.name.indexOf("原发灶或转移灶的影像学检查")>=0) this.mailItems.push(ele)
        //     if(ele.name.indexOf("医学条件确认表")>=0) this.mailItems.push(ele)
        //     if(ele.name.indexOf("购药发票")>=0) this.mailItems.push(ele)
        //   })
        //   console.log("this.mailItems",this.mailItems)
        // }else{//二轮次时,邮寄材料同电审材料一样,发票根据审核人员选择是否显示
        //   temp.forEach(ele=>{
        //     if((!this.patientInfo.phase_info||!this.patientInfo.phase_info.number)&&ele.name.indexOf('购药发票')>=0)  return
        //     this.mailItems.push(ele)
        //   })
        // }

        temp.forEach(ele => {
        if (patient.rounds > 1 && (!this.patientInfo.phase_info || !this.patientInfo.phase_info.number) && ele.name.indexOf('购药发票') >= 0) return
        if (ele.paper_mail_show > 0) this.mailItems.push(ele)
      })


        //审核不通过时展示↓
        let reasons=''
        this.mailItems.forEach(ele=>{
          if(ele.result.status == "审核不通过"){
            this.itemStatus.status="审核不通过"
              reasons+=ele.name+":"+ele.result.reasons+";"
          }
        })
        this.itemStatus.reasons=reasons

        Toast.clear()
        this.isLoading = false
      },
      // goItem(item, index){
      //   console.log("UploadItem", item)
      //   this.$router.push({
      //     name: 'Materials',
      //     query: {
      //       id: item.id,
      //       papid: this.papid,
      //       category: item.category,
      //       active: this.active,
      //       follow: this.follow
      //     }
      //   })
      // },
      showPic(route, index) {
        if(route.length==0) return
        this.src = []
        if (Array.isArray(route)) {
          route.forEach(ele => {
            this.src.push(ele.filepath)
          })
        } else {
          this.src.push(route)
        }
        this.$nextTick(() => {
          ImagePreview({
            images: this.src,
            showIndex: true,
            loop: false,
            startPosition: index ? index : 0,
          })
        })
      },
      async goNext() {
          this.$router.push({name:"Timeline"})
      },
      //通过状态计算图片地址
      // getImgSrc(status,item){
      //   const fileUrl="/static/upload/"
      //   const format=".png"
      //   let imgName="awaitUpload"
      //   console.log(item,status)
      //   if(status=="审核不通过"){
      //     imgName="refuse"
      //   }else if(status=="审核通过"){
      //     imgName="passed"
      //   }else{//查看示例
      //     imgName=checkoutImg
      //   }

      //   imgName=fileUrl+imgName+format

      //   return imgName
      // },
      toastText(text){
        Toast(text)
      },
      item_img_url(item){//材料的第一张图片
        return item.attach[0]?item.attach[0].filepath:''
      }
    },
  }
</script>

<style lang='less'>
  .mailPaperMaterials {
    height: 100%;
    width: 100%;
    padding-bottom: 50px;
    box-sizing: border-box;
    // background-color: white;

    .upload-list {
      box-sizing: border-box;
      margin: 16px;
      border-radius: 10px;
      box-shadow: 0px 1px 10px 0px rgba(3, 121, 255, 0.1);
      border: 1px solid rgba(255, 255, 255, 0);
      overflow: hidden;

      .custom-title{
        
      }
      .van-cell__title{
        flex:3 2;
      }
      .van-cell-group__title {
        background: #FFB253;
        color: #fff;
        padding: 10px;
      }

      .warn {
        color: @red;
      }

      .success {
        color: #6CF025;
      }

      .loading {
        color: #F89900;
      }
    }


    .check {
      width: 92%;
      margin: 0 auto;
      font-size: 13px;

      span {
        color: #5b7096;
      }
    }
    /deep/ .cell-value{
      width:100px !important;
    }
    
    .upload-status {
      box-sizing: border-box;
      padding: 10px 15px;
      margin: 16px;
      border-radius: 10px;
      overflow: hidden;
      background-color: #FFDADB;
      font-size: 14px;
      color:#FF4830;
      .status{
        display: flex;
        align-items: center;
      }
      &.red {
        color: @red;
      }
    }
    .address{
        box-sizing: border-box;
      margin: 5px 16px 16px 16px;
      border-radius: 10px;
      overflow: hidden;
      font-size: 14px;
      
      .status{
        color:#FF4830;
        margin: 0 0 16px 0;
        display: flex;
        align-items: center;
      }
      .copyAddress{
          margin: 5px 0;
          display: flex;
          justify-content:space-between;
      }
    }
    .appoint-notice-container{
      display:flex;flex-flow: column nowrap;justify-content:center;align-items: center;
      .appoint-notice{
        box-sizing: border-box;
        margin: 16px;
        border-radius: 10px;
        box-shadow: 0px 1px 10px 0px rgba(3, 121, 255, 0.1);
        border: 1px solid rgba(255, 255, 255, 0);
        overflow: hidden;
          .address{
            box-sizing: border-box;
            margin: 5px 16px 16px 16px;
            border-radius: 10px;
            overflow: hidden;
            font-size: 14px;
            .appointment-status {
              box-sizing: border-box;
            //   padding: 10px 15px;
            //   margin: 16px;
              border-radius: 10px;
              overflow: hidden;
            //   background-color: #FFDADB;
              font-size: 14px;
              color:#FF4830;
              .img-status{
                display: flex;
                align-items: center;
              }
              &.red {
                color: @red;
              }
            }
          .status{
            color:#FF4830;
            margin: 0 0 16px 0;
            display: flex;
            align-items: center;
          }
          .copyAddress{
              margin: 10px 0;
              display: flex;
              justify-content:space-between;
          }
        }
      }
    }
  }
</style>